import React from "react";
import type { ShopMenuItem } from "../../../../../../domain/types/company-shop";
import { ColorField, Field, Segmented, TextField, ToggleSwitch } from "../ui/SettingsUI";

/*
  헤더 · 푸터가 같이 쓰는 편집 UI.
  - ThemeFields: 프리셋 · 배경색 · 텍스트색
  - MenuItemsEditor: 푸터 메뉴 노출 · 문구
*/

interface ThemeFieldsProps {
  presetKey: string;
  presetOptions: { value: string; label: string }[];
  onPreset: (presetKey: string) => void;
  backgroundColor: string;
  textColor: string;
  onColor: (patch: { backgroundColor?: string; textColor?: string }) => void;
}

export const ThemeFields = ({ presetKey, presetOptions, onPreset, backgroundColor, textColor, onColor }: ThemeFieldsProps) => (
  <>
    <Field label="프리셋" hint={presetKey === "CUSTOM" ? "값을 직접 바꿔 '직접 설정' 상태입니다. 프리셋을 누르면 그 값으로 다시 채워집니다." : undefined}>
      <Segmented ariaLabel="프리셋" value={presetKey} options={presetOptions} onChange={onPreset} />
    </Field>
    <div className="grid grid-cols-2 gap-[0.625rem]">
      <ColorField label="배경색" value={backgroundColor} onChange={(value) => onColor({ backgroundColor: value })} />
      <ColorField label="텍스트색" popoverAlign="end" value={textColor} onChange={(value) => onColor({ textColor: value })} />
    </div>
  </>
);

interface MenuItemsEditorProps {
  items: ShopMenuItem[];
  onChange: (items: ShopMenuItem[]) => void;
}

/** 푸터 메뉴: 문구 · 노출만 바꾼다. 헤더 메뉴는 HeaderMenuEditor 가 따로 맡는다 */
export const MenuItemsEditor = ({ items, onChange }: MenuItemsEditorProps) => {
  const patchItem = (key: string, patch: Partial<ShopMenuItem>) =>
    onChange(items.map((item) => (item.key === key ? { ...item, ...patch } : item)));

  return (
    <div className="flex flex-col gap-[0.375rem]">
      {items.map((item) => (
        <div
          key={item.key}
          className={`flex flex-row items-center gap-[0.5rem] px-[0.625rem] py-[0.5rem] rounded-[8px] border border-[#EEEEEE] ${item.visible ? "bg-white" : "bg-[#FAFAFA]"}`}
        >
          <TextField aria-label={`${item.label} 메뉴 문구`} value={item.label} onChange={(event) => patchItem(item.key, { label: event.target.value })} />
          <ToggleSwitch size="sm" checked={item.visible} onChange={(visible) => patchItem(item.key, { visible })} label={`${item.label} 메뉴 노출`} />
        </div>
      ))}
    </div>
  );
};
